import { useState } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { VisibilityOff, Visibility } from '@mui/icons-material'

const PasswordInput = ({password, setPassword, variant="outlined"}) => {
    const [showPassword, setShowPassword] = useState(false)
    const updatePassword = (e) => setPassword(e.target.value)
    const handleClickShowPassword = () => setShowPassword(!showPassword)

    return (
        <TextField
            type={showPassword ? 'text' : 'password'}
            value={password}
            placeholder="Password"
            variant={variant}
            onChange={updatePassword}
            InputProps={{
                endAdornment:
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                        >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                }
            }
        />
    )
}

export default PasswordInput